// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3ygjK","footer":"ChangeClinic_footer__1it1h"};